import React, { useState,useEffect,useContext } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { ContextData } from '../../../../../../context/Context';
import axios from 'axios';
import baseUrl from "../../../../../../BaseURL";
import Sponsor from "../../Forms/loan/Sponsor";
import SpouseDetails from "../../Forms/loan/SpouseDetails";
import ResdentialAddress from "../../Forms/loan/ResdentialAddress";
import EmploymentDetails from "../../Forms/loan/EmploymentDetails";
import SalaryBankDetails from "../../Forms/loan/SalaryBankDetails";
import PersonalReference from "../../Forms/loan/PersonalReference";
import GuarantorDetails from "../../Forms/loan/GuarantorDetails";
import LoanRequestInfo from "../../Forms/loan/LoanRequestInfo";
import LoanApplicationProfilePreview from "../../Forms/loan/LoanApplicationProfilePreview";


export default function MainPreview() {


  const [activeStep, setActiveStep] = React.useState(0);
  const [Data,setData] = useState(null)
  const {UserTokens,ReloadBioForms,setBioProgressStatus} = useContext(ContextData)










 
  
  return (
   

    <div
      style={{ margin: "2rem auto", maxWidth: "900px", padding: "0 1.5rem" }}
      className="main-preview-con"
    >
      <LoanApplicationProfilePreview  from="mainpreview" applicanttoken={UserTokens} />
      
    </div> 
  );
}

